module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.7655/img/screenshot-twitter.png"